<template>
  <div style="position: relative">
    <v-card flat>
      <div id="controlsContainer">
        <div
          class="card-title table-controls px-3 d-flex align-center justify-space-between"
        >
          <div>
            <!-- CRUD buttons -->
            <!-- dialog for creating item -->
          </div>
          <!-- center side -->
          <div>
            <!-- Search by fields -->
            <!-- Search in table -->
            <v-container id="filterContainer">
              <v-row>
                <v-col sm="4" lg="4" cols="12">
                  <v-dialog
                    v-model="modalFilterDateFrom"
                    :close-on-content-click="false"
                    persistent
                    width="290px"
                    @keydown.esc="modalFilterDateFrom = false"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="filter.dateFromFormatted"
                        :label="$t('statistics.dateFrom')"
                        append-icon="far fa-calendar-alt"
                        readonly
                        clearable
                        v-on="on"
                        @click:clear="filter.dateFrom = null"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="filter.dateFrom"
                      scrollable
                      @input="modalFilterDateFrom = false"
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="primary"
                        @click="modalFilterDateFrom = false"
                      >
                        {{ $t("global.cancel") }}
                      </v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-col>
                <v-col sm="4" lg="4" cols="12">
                  <v-dialog
                    v-model="modalFilterDateTo"
                    :close-on-content-click="false"
                    persistent
                    width="290px"
                    @keydown.esc="modalFilterDateTo = false"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="filter.dateToFormatted"
                        :label="$t('statistics.dateTo')"
                        append-icon="far fa-calendar-alt"
                        readonly
                        clearable
                        v-on="on"
                        @click:clear="filter.dateTo = null"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="filter.dateTo"
                      scrollable
                      @input="modalFilterDateTo = false"
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="primary"
                        @click="modalFilterDateTo = false"
                      >
                        {{ $t("global.cancel") }}
                      </v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-col>
                <v-col sm="4" lg="4" cols="12">
                  <v-select
                    v-model="filter.groupBy"
                    :items="groupByItemsValues"
                    :label="$t('statistics.groupBy')"
                  ></v-select>
                </v-col>
              </v-row>
            </v-container>
            <!-- clear filters -->
          </div>
          <!-- right side -->
          <div>
            <!-- Refresh table -->
            <crud-button
              large
              color="blue"
              @clicked="search()"
              icon="fa-sync-alt"
              :tooltip="$t('global.crud.buttons.refreshTable')"
            />
            <crud-button
              v-if="searched"
              large
              color="green"
              @clicked="doExport()"
              icon="fa-file-export"
              :tooltip="$t('global.crud.buttons.export')"
            />
          </div>
        </div>
      </div>
      <div id="dataContainer">
        <!-- Table -->
        <line-chart
          v-if="searched"
          :chartdata="chartData"
          :options="chartOptions"
        />
      </div>
    </v-card>
  </div>
</template>

<script>
import CrudButton from "@/components/Button.vue";
import localhttp from "../js/https-commons";
import LineChart from "@/components/LineChart";
import moment from "moment";
import { transformDate } from "@/js/utils.js";
import XLSX from "xlsx";

const CONTEXT = "/expeditions";

export default {
  components: {
    CrudButton,
    LineChart
  },
  name: "Statistics",
  data: () => ({
    loading: false,
    searched: false,
    items: [],
    modalFilterDateFrom: false,
    modalFilterDateTo: false,
    filter: {
      allFields: "",
      dateFrom: null,
      dateFromFormatted: "",
      dateTo: null,
      dateToFormatted: "",
      details: true,
      deletedItems: "ALL",
      groupBy: "day"
    },
    chartData: {
      labels: [],
      datasets: [
        {
          id: "expeditions",
          fill: false,
          borderColor: "#00A2E8",
          borderWidth: 2
        },
        {
          id: "scheduled",
          fill: false,
          borderColor: "#ED1C23",
          borderWidth: 2
        }
      ]
    },
    chartOptions: {
      scales: {
        yAxes: [
          {
            ticks: {
              beginAtZero: true
            },
            gridLines: {
              display: true
            }
          }
        ],
        xAxes: [
          {
            gridLines: {
              display: false
            }
          }
        ]
      },
      legend: {
        display: true
      },
      responsive: true,
      maintainAspectRatio: false
    },
    itemData: {
      days: [],
      daysFormat: [],
      expeditions: [],
      schedules: []
    }
  }),
  computed: {
    groupByItemsValues: function() {
      return [
        { text: this.$t("statistics.groupBy.day"), value: "day" },
        { text: this.$t("statistics.groupBy.week"), value: "week" },
        { text: this.$t("statistics.groupBy.month"), value: "month" },
        { text: this.$t("statistics.groupBy.year"), value: "year" }
      ];
    }
  },
  watch: {
    "filter.dateFrom": function() {
      this.filter.dateFromFormatted = this.transformDate(
        this.filter.dateFrom,
        this.$t("global.dateFormat")
      );
    },
    "filter.dateTo": function() {
      this.filter.dateToFormatted = this.transformDate(
        this.filter.dateTo,
        this.$t("global.dateFormat")
      );
    }
  },
  methods: {
    search() {
      console.debug("Search elements");

      this.searched = false;

      // Items have already been requested
      if (this.loading) return;

      this.loading = true;

      localhttp
        .post(CONTEXT + "/statistics", this.filter)
        .then(response => {
          //If no filter, put dates from response
          this.filter.dateFrom = this.transformDate(
            response.data.dateFrom,
            "YYYY-MM-DD"
          );
          //If no filter, put dates from response
          this.filter.dateTo = this.transformDate(
            response.data.dateTo,
            "YYYY-MM-DD"
          );
          this.items = response.data.details;
          this.chartData.labels = [];
          let expeditionLine = this.chartData.datasets.find(
            el => el.id === "expeditions"
          );
          let scheduleLine = this.chartData.datasets.find(
            el => el.id === "scheduled"
          );
          expeditionLine.label =
            this.$t("statistics.expeditions") +
            ": " +
            response.data.totals.expeditions;
          scheduleLine.label =
            this.$t("statistics.schedulings") +
            ": " +
            response.data.totals.scheduled;
          scheduleLine.data = [];
          expeditionLine.data = [];
          this.groupDataByDay();
          if (this.filter.groupBy === "day") {
            this.graphByDay(this.chartData, expeditionLine, scheduleLine);
          } else {
            this.graphByType(
              this.chartData,
              expeditionLine,
              scheduleLine,
              this.filter.groupBy
            );
          }
          this.loading = false;
          this.searched = true;
        })
        .catch(e => {
          console.log(e);
          this.loading = false;
          this.$showError();
        });
    },
    graphByDay(chartData, expeditionLine, scheduleLine) {
      chartData.labels = this.itemData.daysFormat;
      expeditionLine.data = this.itemData.expeditions;
      scheduleLine.data = this.itemData.schedules;
    },
    graphByType(chartData, expeditionLine, scheduleLine, type) {
      let week = -1;
      var self = this;
      this.itemData.days.forEach(function(day, index) {
        let weekYear;
        switch (type) {
          case "month":
            weekYear = moment(day)
              .locale(self.$i18n.locale)
              .format("MMMM-yyyy");
            break;
          case "year":
            weekYear = moment(day)
              .locale(self.$i18n.locale)
              .format("yyyy");
            break;
          default:
            weekYear = moment(day).week() + "-" + moment(day).year();
            break;
        }
        if (chartData.labels.includes(weekYear)) {
          expeditionLine.data[week] += self.itemData.expeditions[index];
          scheduleLine.data[week] += self.itemData.schedules[index];
        } else {
          chartData.labels.push(weekYear);
          expeditionLine.data.push(self.itemData.expeditions[index]);
          scheduleLine.data.push(self.itemData.schedules[index]);
          week++;
        }
      });
    },
    groupDataByDay() {
      this.itemData.days = [];
      this.itemData.daysFormat = [];
      this.itemData.expeditions = [];
      this.itemData.schedules = [];
      for (
        var day = moment(this.filter.dateFrom);
        day.diff(moment(this.filter.dateTo), "days") <= 0;
        day.add(1, "days")
      ) {
        this.itemData.days.push(moment(day));
        this.itemData.daysFormat.push(
          this.transformDate(day, this.$t("global.dateFormat"))
        );
        let dateLoop = this.transformDate(day, "YYYY-MM-DD");
        let stat = this.items.find(el => el.date === dateLoop);
        this.itemData.expeditions.push(
          stat !== undefined ? stat.expeditions : 0
        );
        this.itemData.schedules.push(stat !== undefined ? stat.scheduled : 0);
      }
    },
    doExport() {
      let dataToExport = [];
      let expeditionLine = this.chartData.datasets.find(
        el => el.id === "expeditions"
      );
      let scheduleLine = this.chartData.datasets.find(
        el => el.id === "scheduled"
      );
      if (this.chartData.labels != null && this.chartData.labels.length > 0) {
        this.chartData.labels.forEach(function(value, index) {
          let object = new Object();
          object.date = value;
          object.expeditions = expeditionLine.data[index];
          object.schedules = scheduleLine.data[index];
          dataToExport.push(object);
        });
        //convert to excel
        var ws = XLSX.utils.json_to_sheet(dataToExport);
        var wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "statistics");

        XLSX.writeFile(wb, "statistics.xlsx");
      }
    },
    transformDate
  }
};
</script>
